var $ = require('jquery');

import * as Ajax from './ajax.js';

$(function() {
    //Filter brands
    let brandTimer;
    for (const brandInput of document.querySelectorAll('.js-filter-brands-input')) {
        brandInput.addEventListener('input', (e) => {
            clearTimeout(brandTimer);
            brandTimer = setTimeout(() => {
                getBrandsStartingWith(e.target.value);
            }, 150);
        });
    }
});

//Filter brands. Get brand names starting like input value
function getBrandsStartingWith(brandName)
{
    let params = {
        limit: 10,
    };

    if (brandName.length > 0) {
        params.name = brandName;
    } else {
        params.limit = 100;
    }

    Ajax.get("/api/v4/brand/search", params, true)
    .then(brands => {
        let resultList = $('.js-filter-brands-results').toggleClass('d-none', brands.length === 0);
        $('.js-filter-brands-results').empty();
        $('.js-filter-brands-no-results').toggleClass('d-none', brands.length > 0);
        let template = $('.brand-template').html().trim();
        let currentBrand = $(this).closest('form').find('input[name="brand"]').val();
        for (const brand of brands) {
            let newBrand = $(template);
            newBrand.data('value', brand.slug).data('id', brand.id);
            newBrand.find('.filter-name').text(brand.name);
            newBrand.find('.icon-tick').toggleClass('d-none', brand.slug != currentBrand);
            resultList.append(newBrand);
        }
    });
}
